import React from "react";
import { TCText } from "../TCText/TCText";

type props = {
  text: string;
  onClick: () => void;
  textStyle?: React.CSSProperties;
};

export const ClickableText: React.FC<props> = ({
  text,
  onClick,
  textStyle,
}) => {
  return (
    <div onClick={onClick}>
      <TCText
        style={{
          cursor: "pointer",
          color: "white",
          textDecoration: "underline",
          ...textStyle,
        }}
        value={text}
      />
    </div>
  );
};
